import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'checkout',
  label: 'Checkout Section',
  description: 'The order checkout page section.',
  supportedPages: ['checkout'],
  variants: [{ id: 'v1', label: 'V1 (Apparels)' }],
  commonFields: [
    { key: 'pageTitle', label: 'Page Title', type: 'string', default: 'Checkout' },
    { key: 'loadingText', label: 'Loading Text', type: 'string', default: 'Preparing checkout...' },
    { key: 'emptyTitle', label: 'Empty Cart Title', type: 'string', default: 'Your cart is empty' },
    { key: 'emptyMessage', label: 'Empty Cart Message', type: 'string', default: 'Checkout is only available for shopping carts with items.' },
    { key: 'continueShoppingText', label: 'Continue Shopping Text', type: 'string', default: 'Continue Shopping' },
    { key: 'continueShoppingLink', label: 'Continue Shopping Link', type: 'string', default: '/shop' },
    { key: 'summaryTitle', label: 'Order Summary Title', type: 'string', default: 'Order Summary' },
    { key: 'subtotalLabel', label: 'Subtotal Label', type: 'string', default: 'Subtotal' },
    { key: 'shippingChargeLabel', label: 'Shipping Charge Label', type: 'string', default: 'Shipping Charge' },
    { key: 'shippingCalculatingText', label: 'Shipping Calculating Text', type: 'string', default: 'Calculating...' },
    { key: 'totalLabel', label: 'Total Amount Label', type: 'string', default: 'Total Amount' },
    { key: 'placeOrderText', label: 'Place Order Button Text', type: 'string', default: 'Place Order' },
    { key: 'placingOrderText', label: 'Placing Order Loading Text', type: 'string', default: 'Placing Order...' },
    { key: 'securePaymentText', label: 'Secure Payment Label', type: 'string', default: 'SSL Secure Payment' },
  ],
}
